/* eslint-disable no-unused-vars */
import { call, put, select } from 'redux-saga/effects';
import { getLocale, getToken } from './redux';
import { CONNECTION_ERROR } from '../configs/serverStatusCodes';
import { rejectActionPromise } from './rejectActionPromise';
import { authorizedLogoutSuccessful } from '../modules/Authorized/actions';
import { intlShape } from '../components/base/IntlProviderWrapper';
import { BACKEND_URL } from '../configs';

const isAuthRequest = url => url.includes('/auth/login')
  || url.includes('/auth/logout')
  || url.includes('/auth/user');

const unauthorizedResponse = message => ({
  status: 401,
  message,
  json: () => Promise.resolve({
    error: {
      code: 401,
      message,
      silent: true,
    },
  }),
});

function* ensureAuthorized(url, token, locale) {
  if (isAuthRequest(url)) {
    return true;
  }
  if (!token) {
    return false;
  }

  const response = yield doRequest(
    `${BACKEND_URL}/api/v1/auth/user`,
    'POST',
    token,
    {},
    locale,
    {},
    false,
  );
  return response.status === 200;
}

function* doRequest(url, method, token, pool, locale, headers, noStringify) {
  const {
    formatMessage,
  } = intlShape;
  const data = {
    method,
    cache: 'no-cache',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': locale,
      Authorization: `Bearer ${token}`,
    },
  };
  data.headers = { ...data.headers, ...headers };
  const urlWithQuery = new URL(url);
  if (pool) {
    if (method !== 'GET') {
      if (noStringify) {
        data.body = pool;
        delete data.headers['Content-Type'];
      } else {
        data.body = JSON.stringify(pool);
      }
    } else {
      Object.keys(pool).forEach(key => {
        if (key === 'filter' || key === 'sort') {
          pool[key].forEach(item => urlWithQuery.searchParams.append(key, item));
        } else {
          urlWithQuery.searchParams.append(key, pool[key]);
        }
      });
    }
  }
  let fetchData = null;
  try {
    fetchData = yield fetch(urlWithQuery, data);
  } catch (e) {
    fetchData = { status: CONNECTION_ERROR, message: formatMessage({ id: 'error.connection' }) };
  }
  return fetchData;
}

export default function* makeRequest(url, pool = {}, action, method = 'POST', removeToken = false, headers = {}, noStringify = false) {
  const {
    formatMessage,
  } = intlShape;
  const token = yield select(getToken);
  const locale = yield select(getLocale);
  try {
    const authorized = yield ensureAuthorized(url, token, locale);
    if (!authorized) {
      yield put(authorizedLogoutSuccessful());
      window.location.href = '/';
      return unauthorizedResponse(formatMessage({ id: 'error.code.401' }));
    }

    const userDataResponse = yield doRequest(url, method, token, pool, locale, headers, noStringify);
    if (userDataResponse.status === 401 && !url.includes('/auth/login')) {
      yield put(authorizedLogoutSuccessful());
      window.location.href = '/';
    }
    return userDataResponse;
  } catch (e) {
    const userDataResponse = { status: CONNECTION_ERROR, message: formatMessage({ id: 'error.connection' }) };
    yield call(rejectActionPromise(action, userDataResponse));
    return userDataResponse;
  }
}
